import {Component, NgZone, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {ConfigService} from '../services/config.service';
import {EventsEmitterService} from '../services/emitter.service';
import {LogService} from '../services/log.service';
import {SecurityService} from '../services/security.service';
import {VisualsService} from '../services/visuals.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ui-nav-header',
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {
  public alerts: any = [];
  public unreadMessages = 0;
  public timerInterval: any;
  public genericVisuals: any = {};
  public langs = [];
  public user: any = {};
  public username: string;

  public status: {isopen: boolean} = {isopen: false};
  constructor(
    public securityService: SecurityService,
    public eventsEmitterService: EventsEmitterService,
    public logger: LogService,
    public ngZone: NgZone,
    public visualsService: VisualsService,
    public translateService: TranslateService,
    public configService: ConfigService,
    public renderer: Renderer2,
  ) {
    this.langs = this.configService.getLangs();
    this.visualsService.setLangId(this.configService.getLangDefault());

    this.getGenericVisuals();
    this.eventsEmitterService.languageChange.subscribe({
      next: (langId) => {
        this.getGenericVisuals();
        this.visualsService.setLangId(langId);
        this.translateService.use(this.configService.getLangTextByLangId(langId));
      },
    });
    this.getUser();
  }

  public getUser(): void {
    this.username = localStorage.getItem('userName');
    this.user =
      localStorage.getItem('home_info') == null
        ? {}
        : this.visualsService.getFromStorageAsJSON('home_info', false);
  }

  public getGenericVisuals() {
    this.genericVisuals = this.visualsService.getFromStorageAsJSON('visualsArray')['generic'];
  }

  public disabled: boolean = false;

  ngOnInit() {}

  public changeLang(langId: string) {
    localStorage.setItem('langId', langId);
    this.logger.log('new lang ' + langId);
    this.eventsEmitterService.languageChange.emit(langId);
  }

  public toggled(open: any): void {
    this.logger.log('Dropdown is now: ' + open);
  }

  public toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.logger.log('Event:' + $event);
    this.status.isopen = !this.status.isopen;
  }

  public logout() {
    this.securityService.logout();
  }

  public changeTheme() {
    if (document.body.classList.contains('theme-light')) {
      document.body.classList.remove('theme-light');
      document.body.classList.add('theme-dark');
    } else if (document.body.classList.contains('theme-dark')) {
      document.body.classList.remove('theme-dark');
      document.body.classList.add('theme-light');
    }
  }

  ngOnDestroy() {
    // Will clear when component is destroyed e.g. route is navigated away from.
    clearInterval(this.timerInterval);
  }
}
